export default "data:image/webp;base64,UklGRjYAAABXRUJQVlA4TCkAAAAvJ4AGACASIPmDC/w/zG4iCgSS/f3iWSBAlJBvU/8nYK95S3MQngJ/AAA="